import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana24Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
   <rect width="1221" height="921" fill="url(#pattern0_1467_39208)"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("4"))}     
    d="M340.128 614.11L349.125 569.126L459.336 596.117L450.339 641.101L430.096 650.098L349.125 629.855C340.128 624.457 339.378 617.109 340.128 614.11Z" 
    fill={getFillByLot(4, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}     
    d="M506.57 623.111L450.34 641.104L481.829 501.654L531.312 512.9L506.57 623.111Z" 
    fill={getFillByLot(3, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}     
    d="M580.793 602.866L506.57 623.108L531.311 512.897L596.538 528.642L580.793 602.866Z" 
    fill={getFillByLot(2, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}     
    d="M708.995 582.62L580.79 602.863L596.534 528.64L735.985 562.378C732.386 571.374 716.492 580.371 708.995 582.62Z" 
    fill={getFillByLot(1, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("11"))}     
    d="M733.738 526.392C739.136 542.587 737.487 557.131 735.987 562.38L616.78 533.14L637.023 467.913L733.738 526.392Z" 
    fill={getFillByLot(11, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("10"))}     
    d="M562.8 425.175L637.024 467.91L616.781 533.137L540.308 515.143L562.8 425.175Z" 
    fill={getFillByLot(10, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("9"))}     
    d="M506.577 393.689L562.807 425.178L540.315 515.146L481.836 501.651L506.577 393.689Z" 
    fill={getFillByLot(9, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("8"))}     
    d="M434.601 353.203L506.576 393.689L495.33 436.424L389.617 409.434L400.863 355.453C409.86 346.456 427.104 350.205 434.601 353.203Z" 
    fill={getFillByLot(8, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("7"))}     
    d="M378.365 461.165L389.611 409.433L495.324 436.424L484.078 488.155L378.365 461.165Z" 
    fill={getFillByLot(7, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("6"))}     
    d="M364.873 515.148L378.368 461.167L484.081 488.157L472.835 544.387L364.873 515.148Z" 
    fill={getFillByLot(6, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("5"))}     
    d="M349.126 569.126L364.87 515.145L472.832 544.385L459.337 596.116L349.126 569.126Z" 
    fill={getFillByLot(5, selected, lands)} 
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_39208" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_39208" transform="matrix(0.00308515 0 0 0.00409009 -6.05272 -1.31715)"/>
    </pattern>
    <image id="image0_1467_39208"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
  </svg>
  );
};